/* eslint-disable no-use-before-define,no-unused-expressions,no-eval,no-restricted-globals */
import React from 'react'
import {
    ajax, atmosphere,
    getParm,
    Status,
    subscribe, publish, unsubscribe,
    Loading,
    $,
    setScroll,
    initTwdToken,
    arrayFrom,
    getConfig,
} from '../twd/twd'

import initNav from './init-nav';
import { getUrlDefaultValues, getUrlLinkInfo } from './init-url'
import { getUserHoldings, setUserHoldings } from './init-holdings'
import { initTime } from './init-time'

const isDev = document.location.href.indexOf('localhost') > 0
const defaultStatus = isDev ? Status.LOADED : Status.LOADING

export const AppContext = React.createContext()
export const APP = {
    isDev,
    ajax,
    publish,
    subscribe,
    unsubscribe,
    config: {},
}
global.app = APP

export const AppContextProvider = ({children}) => {
    const [status, setStatus] = React.useState(defaultStatus)

    const { defaultView, defaultArgs, defaultModal, defaultModalArgs } = getUrlDefaultValues()
    const [view, setView] = React.useState(defaultView)
    const [args, setArgs] = React.useState(defaultArgs)
    const [modal, setModal] = React.useState(defaultModal)
    const [modalArgs, setModalArgs] = React.useState(defaultModalArgs)
    const [modal2, setModal2] = React.useState(null)
    const [modal2Args, setModal2Args] = React.useState(null)
    const [is401, setIs401] = React.useState(false)
    initNav({view, args, modal, modal2, setView, setArgs, setModal, setModalArgs, setModal2, setModal2Args, setIs401})

    React.useEffect(() => {(async () => {
        if (status!==Status.LOADING) return

        let keys = [
            // 'atmosphere_url',
            'notifier_url',
            'bw_service_host',
            'entitlements',
            'user',
            'previous_business_day',
            'next_holiday',
            'working_holiday',
            'end_of_day_time',
            'prev_end_of_day_time',
            'state_rates',
            'account_states', // todo: add user account state
            {'parm': [
                'ENSIGHTEN-TAGGING-URL',
                'BRIDGE-ETNAVJS',
                'BRIDGE-ETNAVTOKEN',
                'BRIDGE-AATID'
            ]}
        ]

        try {
            let {data} = await ajax({
                url: '/esb/generic/masterConfig?firstLoad=true',
                method: 'POST',
                body: JSON.stringify(keys)
            })
            let cfg = await data
            cfg.state_tax_rates = arrayFrom(cfg.state_rates)
                .reduce ( (x, a) => ( {...x, ...{[a.Description]: a.Value} } ), {})
            APP.config = cfg

            await initStyles()
            await initTwdToken()
            await initTime()

            atmosphere(cfg, [
                // 'allocation',
                // 'account.alert.detail',
                // 'account.alert.summary',
                // 'account.alert.subscription.reject',
                // 'account.material.alert',
                'bidoffer.new',
                'bidoffer.change',
                'bidoffer.status',
                'bidoffer.status.cancelled',
                'bidoffer.status.expired',
                'bidoffer.status.rejected',
                'bidoffer.status.replaced',
                'bidoffer.status.showing',
                'circle.change',
                'circle.expire',
                'circle.new',
                'circle.notify',
                'circle.status',
                'order.change',
                'order.new',
                'order.status',
                'order.status.cancelled',
                'order.status.expired',
                'order.status.filled',
                'order.status.rejected',
                'order.statusnote',
                // 'ps.report.scheduled',
                // 'ps.proposal.published',
                // 'rep.alert.new',
                // 'send.cusip',
                // 'send.ladder',
                // 'user.logout',
                // 'watchlist.match',
                // 'watchlist.tick',
                // 'watchlist.timeout'
            ].filter(Boolean))

            let tagUrl = getParm('ENSIGHTEN-TAGGING-URL')
            if (tagUrl) {
                // etrade provided script, creates temp style
                !function(e,a,n,t){
                    var i=e.head;
                    if(i){
                        if (a) return;
                        var o=e.createElement("style");
                        o.id="alloy-prehiding";
                        o.innerText=n;
                        i.appendChild(o);
                        setTimeout(function(){o.parentNode&&o.parentNode.removeChild(o)},t)
                    }
                }(document, document.location.href.indexOf("adobe_authoring_enabled") !== -1, ".personalization-container { opacity: 0 !important }", 3000);

                let el = document.createElement('script')
                el.setAttribute('type', 'text/javascript')
                el.setAttribute('src', tagUrl)
                el.setAttribute('async', true)
                document.head.appendChild(el)
            }

            let etNavJs = getParm('BRIDGE-ETNAVJS')
            if (etNavJs) {
                global.etBellaNavToken = getParm('BRIDGE-ETNAVTOKEN')

                let el = document.createElement('script')
                el.setAttribute('type', 'text/javascript')
                el.setAttribute('src', etNavJs)
                document.head.appendChild(el)
            }

            let aatid = getParm('BRIDGE-AATID')
            if (aatid) {
                document.body.setAttribute('aatid', aatid)
            }

            await getUrlLinkInfo({setView, setArgs, setModal, setModalArgs})
            await getUserHoldings()

            Array.from(document.getElementsByTagName("etrade-footer"))
            .forEach(e => e.style.display = '')

            setStatus(Status.LOADED)
        } catch(e) {
            setStatus(Status.FAILED_TO_LOAD)
        }
    })()}, [status])

    React.useEffect(() => {
        let subId = subscribe('user-holdings.app', (rs) => {
            setUserHoldings(rs)
        })
        return () => {
            if (subId) unsubscribe(subId)
        }
    }, [])

    return (
    <AppContext.Provider value={{ ...APP, is401, view, args, modal, modalArgs, modal2, modal2Args, status, Status, Loading }}>
    {children}
    </AppContext.Provider>
    )
}

const initStyles = () => {
    if (getConfig('entitlements.ETradeBlue', 'No') !== 'Yes') { return }

    document.documentElement.style.cssText=`
        --primary-base-color: #1173B0;
        --primary-dark-color: #0B4D85;
        --secondary-base-color: #599DC8;
        --primary-outline-color: #1173B0;
        --primary-background-color: #1173B0;
        --primary-disabled-color: #9CC3DD;
        --primary-hover-color: #e9f2f9;
        --btn-border-radius: 22px;
        --snakbar-background-color: #002451;
    `
}

export const useAppContext = () => React.useContext(AppContext)

$(() => {
    let u = new URL(location.href)
    setTimeout(() => {
        setScroll(u.hash)
    }, 2000)
})